import { motion } from "framer-motion";
import { Megaphone, TrendingUp, Target, Palette } from "lucide-react";

const services = [
  {
    n: "01",
    icon: Megaphone,
    title: "Digital Advertising",
    desc: "High-converting paid campaigns across Meta, Google, TikTok and beyond — engineered to put your brand in front of the right eyes.",
  },
  {
    n: "02",
    icon: TrendingUp,
    title: "Brand Scaling",
    desc: "Growth systems that take you from unknown to unavoidable. We build the engine that turns attention into revenue.",
  },
  {
    n: "03",
    icon: Palette,
    title: "Creative Strategy",
    desc: "Scroll-stopping creative rooted in psychology and data. Bold ideas that make people stop, feel, and act.",
  },
  {
    n: "04",
    icon: Target,
    title: "Performance Marketing",
    desc: "Every dollar tracked, every result measured. We optimise relentlessly so your spend compounds into scale.",
  },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.3em] uppercase text-yellow-400 font-semibold">
                01 — Services
              </span>
            </div>
            <h2 className="font-display font-semibold tracking-tight text-white text-4xl sm:text-6xl uppercase leading-[0.95]">
              What We <span className="text-yellow-400">Do</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-zinc-400 text-base leading-relaxed">
              Four disciplines, one obsession: making your brand grow faster than
              it has any right to.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 border-t border-l border-white/10">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                custom={i}
                variants={fade}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                data-testid={`service-card-${s.n}`}
                className="group relative p-8 md:p-12 border-b border-r border-white/10 hover:bg-yellow-400/[0.03] transition-colors"
              >
                <div className="flex items-start justify-between mb-10">
                  <Icon className="text-yellow-400" size={34} strokeWidth={1.5} />
                  <span className="font-display text-5xl text-zinc-800 group-hover:text-yellow-400/30 transition-colors">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display text-2xl sm:text-3xl text-white mb-4 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed max-w-md">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
